import { render, staticRenderFns } from "./AuthMenu.vue?vue&type=template&id=64e45eb3&scoped=true&"
import script from "./AuthMenu.vue?vue&type=script&lang=ts&"
export * from "./AuthMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AuthMenu.vue?vue&type=style&index=0&id=64e45eb3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e45eb3",
  null
  
)

export default component.exports